import { fetchJSON } from '@eventbrite/http';
import { Trial, TrialListResponse } from '../types';

export const getTrials = async (organizationId: string): Promise<Trial[]> => {
    const { trials } = (await fetchJSON(
        `/api/v3/trials/organizations/${organizationId}/trials`,
        { method: 'GET' },
    )) as TrialListResponse;

    return trials;
};

export const startTrial = async (organizationId: string): Promise<Trial> => {
    return (await fetchJSON(
        `/api/v3/trials/organizations/${organizationId}/trials`,
        { method: 'POST' },
    )) as Trial;
};
